import React from 'react'
import { useState } from 'react'
import ResultItem from '../../../pack/form/result/ResultItem'
import WorkLinePlaceResultWarehouse from './WorkLinePlaceResultWarehouse'
import WorkLinePlaceResultFactory from './WorkLinePlaceResultFactory'
import { getWorkPlaceTypeWork } from '../../../../helpers/workPlace/WorkPlaceHelper'
import WorkLinePlaceConfirm from '../WorkLinePlaceConfirm'
import WorkLinePlaceForm from '../WorkLinePlaceForm'
import WorkLinePlaceGroup from '../../group/WorkLinePlaceGroup'

const WorkLinePlaceResult = ({ result, isWorkNow }) => {

    const [open, setOpen] = useState(true)

  return (
    <div className='packResultBlock'>
        <p className='packResultBlock__text'>
            {
                isWorkNow ? 
                    'Зараз Ви на робочому місці' 
                :
                    'Перевірте отримані дані і погодьтеся з ними'
            }
        </p>
        <div className='packResultBlock__list'>
            <ResultItem
                text='Місце фіксації'
                value={result && result.department ? result.department.typeName : ''}
            />

            <WorkLinePlaceResultWarehouse 
                result={result}
            />
            <WorkLinePlaceResultFactory 
                result={result}
            />

            <ResultItem
                text='Назва місця'
                value={result && result.workLinePlace ? result.workLinePlace.name : ''}
            />
            {
                result.typeWork ?
                    <ResultItem
                        text='Тип дії'
                        value={getWorkPlaceTypeWork(result.typeWork)}
                    />
                : ''
            }
        </div>

        {
            isWorkNow ?
                <WorkLinePlaceGroup 
                    workLinePlace={result.workLinePlace}
                    department={result.department}
                />
            : ''
        }

        {
            isWorkNow ?
                <div>
                    <br />
                    <br />
                    <p className='packResultBlock__text'>
                        Для завершення робочого процесу відскануйте QR-код на своєму робочому місці
                    </p>
                    <WorkLinePlaceForm />
                </div>
            : ''
        }

        {
            open ?
                <WorkLinePlaceConfirm 
                    scaned={result.scaned}
                    type={result.type}
                    setOpen={setOpen}
                />
            : ''
        }
    </div>
  )
}

export default WorkLinePlaceResult